export default [
  { id: 1, rule: 'Pas encore disponible!', ruleComment: 'bientôt bébé, bientôt', category: 'card.rule' }
]
